import fetch from '../utils/fetch';
import {ApiURL} from './config';

class AuthApi {

    static login(credentials) {
        let data = new FormData();
        data.append('email', credentials.email);
        data.append('password', credentials.password);
        return fetch(`${ApiURL}/authenticate`, {
            method: 'POST',
            body: data
        });
    }

    static isLoggedIn(){
        let me = localStorage.getItem('me');
        me = JSON.parse(me);
        return (me && typeof me.id!=undefined);
    }
}

export default AuthApi;


/** WEBPACK FOOTER **
 ** ./src/api/authApi.js
 **/